import { IHinhThucMienGiamRequest } from "../models/request/hinh-thuc-mien-giam/IHinhThucMienGiamRequest";
import { apiClient } from "./apiClient";

export const HINH_THUC_MIEN_GIAM_API_END_POINT = "hinh_thuc_mien_giam";

export const hinhThucMienGiamApi = {
  selectByCoso: (dm_coso_id: number) =>
    apiClient.get(`${HINH_THUC_MIEN_GIAM_API_END_POINT}/co_so/${dm_coso_id}`),
  selectAllByNamHoc: (
    nam_hoc: string,
    ts_hocsinh_id: number,
    dm_coso_id: number
  ) =>
    apiClient.get(
      `${HINH_THUC_MIEN_GIAM_API_END_POINT}/select_all_by_namhoc/${nam_hoc}/${ts_hocsinh_id}/${dm_coso_id}`
    ),
  selectAllByNamHocCoso: (
    nam_hoc: string,
    dm_coso_id: number
  ) =>
    apiClient.get(
      `${HINH_THUC_MIEN_GIAM_API_END_POINT}/nam_hoc/${nam_hoc}/co_so/${dm_coso_id}`
    ),
  selectByHocSinh: (nam_hoc: string, ts_hocsinh_id: number) =>
    apiClient.get(
      `${HINH_THUC_MIEN_GIAM_API_END_POINT}/select_by_hocsinh/${nam_hoc}/${ts_hocsinh_id}`
    ),

  insertDeXuatMienGiam: (request: IHinhThucMienGiamRequest) =>
    apiClient.post(
      `${HINH_THUC_MIEN_GIAM_API_END_POINT}/insert_de_xuat_mien_giam`,
      request
    ),
  deleteDeXuatMienGiam: (request: IHinhThucMienGiamRequest) =>
    apiClient.post(
      `${HINH_THUC_MIEN_GIAM_API_END_POINT}/delete_de_xuat_mien_giam`,
      request
    ),
  select_hinhthuctinhs: () =>
    apiClient.get(`hinh_thuc_mien_giam_hinh_thuc_tinh`),
  select_hinhthucnopbom: () => apiClient.get(`sf_hinhthucnopbom`),
  insert: (payload: any) =>
    apiClient.post(`${HINH_THUC_MIEN_GIAM_API_END_POINT}`, payload),
  update: (payload: any) =>
    apiClient.put(`${HINH_THUC_MIEN_GIAM_API_END_POINT}`, payload),
  delete: (ids: number[]) =>
    apiClient.post(`${HINH_THUC_MIEN_GIAM_API_END_POINT}/delete`, ids),
  // Chi tiết miễn giảm
  select_chitiets: (sf_hinhthucmiengiam_id: number) =>
    apiClient.post(
      `hinhthucmiengiam_chitiet/select_by_hinhthuc?sf_hinhthucmiengiam_id=${sf_hinhthucmiengiam_id}`
    ),
  save_changes_chitiets: (data: any) =>
    apiClient.post(`hinhthucmiengiam_chitiet/save_changes`, data),
  update_chitiet: (data: any) =>
    apiClient.post(`hinhthucmiengiam_chitiet/update`, data),
  delete_chitiet: (id: number) =>
    apiClient.post(`hinhthucmiengiam_chitiet/delete`, id),
};
